import { Table } from '@maia/ui';
import { createFileRoute } from '@tanstack/react-router';
import { useAttachmentTable } from '../../../../features/shared/attachments/attachments-table';
import { getClaimOptions } from '../../../../features/claim/claim/queryOptions';

export const Route = createFileRoute(
  '/_authenticated/claims/$guid/_layout/documents',
)({
  component: Page,
  loader: ({ context: { queryClient }, params: { guid } }) =>
    queryClient.ensureQueryData(getClaimOptions(guid)),
});

function Page() {
  const data = Route.useLoaderData();

  const table = useAttachmentTable(data.attachments ?? []);

  return (
    <div className="content-grid">
      <div className="col-span-full flex items-center justify-between">
        <Table table={table} className="grid-cols-[auto_min-content]" />
      </div>
    </div>
  );
}
